import { counterpartApi } from 'components/shared/ProductAndClientSelector/ClientSelector';
import { SalesCounterPartResult } from 'components/shared/SalesCounterPart/SalesCounterPartResult';
import { SelectSearch } from 'components/shared/SelectSearch/SelectSearch';
import { ISalesCounterpart } from 'models/ISalesCounterpart';

type Props = {
  selectedClient?: Nullable<ISalesCounterpart>;
  onClientSelected: (client: ISalesCounterpart | null) => void;
  onClientSearch?: () => void;
  showHeader?: boolean;
};

export function SelectSearchClient({ selectedClient, onClientSelected, showHeader, onClientSearch }: Props) {
  return (
    <SelectSearch
      className="h-100"
      autofocus
      size="xl"
      defaultValue={selectedClient?.label}
      getSearchResult={txt => {
        onClientSearch?.();
        return counterpartApi.fetchSalesCounterparts(txt);
      }}
      onValueSelected={onClientSelected}
      resultRenderer={v => <SalesCounterPartResult showHeader={showHeader} {...v} isClientLabelWrapped />}
    />
  );
}
